/**
 * 用户铭牌组件
 */
import ArkLoader from '@src/js/common/ark-extensions';
import componentConfig from './component-config';
import { IExtension } from '@tencent/ark-extensions';
import { AvatarNickNameplateOptions } from './type';
import nickNameplateDocsComponentConfig from '@src/js/common/ark-extensions/dc-components/avatar-nick-nameplate/component-config';

export async function showAvatarNickNameplate(options: AvatarNickNameplateOptions): Promise<IExtension> {
    const avatarNickNameplateExtension = await ArkLoader.extensionService.getExtension(componentConfig.name);
    avatarNickNameplateExtension.show(options);
    return avatarNickNameplateExtension;
}

export async function loadAndShowAvatarNickNameplate(options: AvatarNickNameplateOptions): Promise<IExtension> {
    await ArkLoader.extensionService.scanAndHandleExtensions([nickNameplateDocsComponentConfig]);
    const avatarNickNameplateExtension = await ArkLoader.extensionService.getExtension(componentConfig.name);
    avatarNickNameplateExtension.show(options);
    return avatarNickNameplateExtension;
}
